import {
  AddDiscordIntegrationChannelDrawerContent,
  AddQualtricsIntegrationChannelDrawerContent,
  AddSlackIntegrationChannelDrawerContent,
  AddSurveyMonkeyIntegrationChannelDrawerContent,
  AddTypeformIntegrationChannelDrawerContent,
} from '@modules/integrationsV2/components/AddIntegrationChannelDrawer/AddIntegrationChannelDrawerContent';
import { AddIntegrationChannelDrawerContentProps } from '@modules/integrationsV2/types';
import { Box, Drawer } from '@mui/material';
import { IntegrationChannelType } from 'generated/graphql';

const channelTypeToAddIntegrationChannelDrawerContentMap: Record<
  string,
  (props: AddIntegrationChannelDrawerContentProps) => JSX.Element
> = {
  [IntegrationChannelType.Slack]: AddSlackIntegrationChannelDrawerContent,
  [IntegrationChannelType.Discord]: AddDiscordIntegrationChannelDrawerContent,
  [IntegrationChannelType.SurveyMonkey]:
    AddSurveyMonkeyIntegrationChannelDrawerContent,
  [IntegrationChannelType.Typeform]: AddTypeformIntegrationChannelDrawerContent,
  [IntegrationChannelType.Qualtrics]:
    AddQualtricsIntegrationChannelDrawerContent,
};

export const AddIntegrationChannelDrawer = ({
  isOpen,
  onDrawerClose,
  integrationID,
  integrationData,
  integrationType,
  integrationChannel,
  channelDescriptions,
}: Omit<AddIntegrationChannelDrawerContentProps, 'onCancel'> & {
  isOpen: boolean;
}) => {
  const AddIntegrationChannelDrawerContent =
    channelTypeToAddIntegrationChannelDrawerContentMap[integrationChannel.type];

  if (!AddIntegrationChannelDrawerContent) {
    return null;
  }

  return (
    <>
      <Drawer
        open={isOpen}
        anchor="right"
        onClose={onDrawerClose}
        keepMounted={false}
      >
        <Box width="45vw" minWidth="700px" height="100vh" overflow="auto">
          <AddIntegrationChannelDrawerContent
            onDrawerClose={onDrawerClose}
            integrationID={integrationID}
            integrationData={integrationData}
            integrationChannel={integrationChannel}
            integrationType={integrationType}
            channelDescriptions={channelDescriptions}
          />
        </Box>
      </Drawer>
    </>
  );
};
